import React from 'react';
import { Box, Alert,   Container,AlertTitle, Button, Chip, Stack } from '@mui/material';
import { Warning as WarningIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { OnboardingProgressResponse, MemberProfile } from '../../types/memberProfile';
import { InfoIcon } from 'lucide-react';
interface OnboardingWarningBarProps {
  onboardingData: OnboardingProgressResponse;
  onShowOnboarding: () => void;
  memberProfile?: MemberProfile;
}

const OnboardingWarningBar: React.FC<OnboardingWarningBarProps> = ({
  onboardingData,
  onShowOnboarding,
  memberProfile,
}) => {
  if (onboardingData.hasCompletedMandatory) {
    return null; // Don't show warning if onboarding is complete
  }

  // Check if member profile is suspended
  const isSuspended = memberProfile?.status === 'suspended';

  const getStepDisplayName = (step: string): string => {
    switch (step) {
      case 'billingSetup':
        return 'Billing Setup';
      case 'documentReview':
        return 'Document Review';
      default:
        return step;
    }
  };

  const pendingStepsCount = onboardingData.pendingSteps.length;
  const pendingStepsText = onboardingData.pendingSteps
    .map(getStepDisplayName)
    .join(', ');

  return (
    <Box sx={{ 
      width: { xs: 'calc(100% + 48px)', sm: '80%' }, 
      mb: 2, 
      mx: { xs: -3, sm: 'auto' },
      mt: { xs: -3, sm: 0 }
    }}>
      <Alert 
        severity="warning" 
        icon={<InfoIcon />}
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', flex: 1 }}>
          <Box>
            <AlertTitle sx={{ mb: 0, fontSize: { xs: '0.875rem', sm: '1rem' }, fontWeight: 600 }}>
              {isSuspended ? 'Your account has been suspended' : 'Complete Your Onboarding'}
            </AlertTitle>
            <Box sx={{ mt: 0.5, fontSize: '0.875rem', display: { xs: 'none', sm: 'block' } }}>
              {isSuspended 
                ? 'Add your payment information in the "Billing" section'
                : `You have ${pendingStepsCount} pending step${pendingStepsCount > 1 ? 's' : ''}: ${pendingStepsText}`
              }
            </Box>
          </Box>
          
          {/* <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
            {onboardingData.pendingSteps.map((step) => (
              <Chip
                key={step}
                label={getStepDisplayName(step)}
                color="warning"
                variant="outlined"
                size="small"
                icon={<WarningIcon sx={{ fontSize: '1rem' }} />}
              />
            ))}
          </Stack> */}
        </Box>

        <Stack direction="row" spacing={1}>
          <Button 
            variant="contained" 
            size="small"
            onClick={onShowOnboarding}
            sx={{ 
              bgcolor: 'warning.main',
              color: 'warning.contrastText',
              '&:hover': {
                bgcolor: 'warning.dark',
              },
              minWidth: { xs: 'auto', sm: '64px' },
              px: { xs: 1.5, sm: 2 }
            }}
          >
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Get Started</Box>
            <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Go</Box>
          </Button>
        </Stack>
      </Alert>
    </Box>
  );
};

export default OnboardingWarningBar;